import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 12px;
  height: 12px;
  color: #cccccc;

  /* TODO Remove this and style using the surrounding button */
  &:hover {
    color: #aaa;
  }
`

const TriangleDown2 = ({ title = 'Down', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 64 64" title={title} {...rest}>
    <path
      fill="currentColor"
      d="M60.893,12.549C60.723,12.212,60.377,12,60,12H4c-0.377,0-0.723,0.212-0.893,0.549 c-0.17,0.337-0.137,0.741,0.088,1.044l28,38C31.384,51.849,31.683,52,32,52s0.616-0.151,0.805-0.407l28-38 C61.029,13.29,61.062,12.886,60.893,12.549z"
    />
  </StyledIcon>
)

TriangleDown2.displayName = 'TriangleDown'
TriangleDown2.needsWork = true
export default TriangleDown2
